import type { ProductAnalysisSectionKey } from "./productAnalysis.js";
import type { RatingComponentKey } from "./productAnalysisRating.js";

export const PRODUCT_ANALYSIS_RULES_VERSION = "product-analysis-rules@0.9.0";

export const PRODUCT_ANALYSIS_RATING_WEIGHTS_VERSION = "rating-weights@0.8.0";

export const PRODUCT_ANALYSIS_RATING_WEIGHTS: Record<RatingComponentKey, number> = {
  profitPerUnit: 0.2,
  netProfit: 0.15,
  roiPercent: 0.15,
  marginPercent: 0.1,
  inStockDailySales: 0.1,
  stabilityScore: 0.1,
  returnRate: 0.1,
  netRevenue: 0.05,
  unitProfitBuffer: 0.05,
};

export const PRODUCT_ANALYSIS_ECONOMICS_LIMITATIONS_BASE = [
  "Себестоимость = актуальный offer_cost, не партия на дату продажи",
] as const;

export const PRODUCT_ANALYSIS_ECONOMICS_PROMO_EXCLUDED =
  "Расходы на продвижение Ozon Performance не учтены";

export const PRODUCT_ANALYSIS_ECONOMICS_UNATTRIBUTED_PROMO =
  "Неатрибутированный расход на продвижение не распределён по SKU";

export const PRODUCT_ANALYSIS_ECONOMICS_LIMITATIONS = [
  PRODUCT_ANALYSIS_ECONOMICS_PROMO_EXCLUDED,
  ...PRODUCT_ANALYSIS_ECONOMICS_LIMITATIONS_BASE,
] as const;

export const PRODUCT_ANALYSIS_PROMOTION_LIMITATIONS = [
  "Неатрибутированный расход на продвижение не распределён по SKU",
] as const;

export const PRODUCT_ANALYSIS_MAX_PERIOD_DAYS = 366;

export const PRODUCT_ANALYSIS_SECTION_KEYS: ProductAnalysisSectionKey[] = [
  "finance",
  "sales",
  "availability",
  "economics",
  "trend",
  "promotion",
  "rating",
  "signals",
];

export const PRODUCT_ANALYSIS_LIMITATIONS: Record<ProductAnalysisSectionKey, string> = {
  finance: "Финансовые операции Ozon ещё не импортируются",
  sales: "Продажи и возвраты ещё не рассчитываются",
  availability: "FBO-наличие и скорость продаж ещё не рассчитываются",
  economics: "Экономика товара ещё не рассчитывается",
  trend: "Тренд и стабильность ещё не рассчитываются",
  promotion: "Продвижение ещё не анализируется",
  rating: "Рейтинг и запас прочности ещё не рассчитываются",
  signals: "Сигналы ещё не формируются",
};
